'use client';

import { SignIn } from '@clerk/nextjs';
import { Compass } from 'lucide-react';
import { useSearchParams } from 'next/navigation';
import Link from 'next/link';

export default function SignInPage() {
  const searchParams = useSearchParams();
  const redirectUrl = searchParams?.get('redirect_url') || '/';
  const callbackUrl = `/auth/callback?redirect_url=${encodeURIComponent(redirectUrl)}`;
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="flex justify-center">
            <Link href="/en" className="cursor-pointer transition-opacity hover:opacity-80">
              <div className="bg-primary-600 p-3 rounded-full">
                <Compass className="h-8 w-8 text-white" />
              </div>
            </Link>
          </div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Sign In
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Welcome back! Please sign in to your account.
          </p>
        </div>

        {/* Clerk SignIn Component */}
        <div className="bg-white py-8 px-6 shadow-xl rounded-lg">
          <SignIn 
            appearance={{
              elements: {
                formButtonPrimary: 'bg-primary-600 hover:bg-primary-700 text-white',
                card: 'shadow-none',
                headerTitle: 'text-gray-900',
                headerSubtitle: 'text-gray-600',
                socialButtonsBlockButton: 'border-gray-300 hover:bg-gray-50',
                formFieldInput: 'border-gray-300 focus:border-primary-500 focus:ring-primary-500',
                footerActionLink: 'text-primary-600 hover:text-primary-500',
                identityPreviewText: 'text-gray-600',
                formFieldLabel: 'text-gray-700',
                formFieldSuccessText: 'text-green-600',
                formFieldErrorText: 'text-red-600',
              },
              variables: {
                colorPrimary: '#059669', // primary-600
                colorBackground: '#ffffff',
                colorText: '#111827',
                colorTextSecondary: '#6b7280',
                colorInputBackground: '#ffffff',
                colorInputText: '#111827',
              }
            }}
            forceRedirectUrl={callbackUrl}
            signUpUrl="/auth/sign-up"
          />
        </div>

        {/* Footer */}
        <div className="text-center">
          <p className="text-xs text-gray-500">
            Your data is protected with enterprise-grade security.
          </p>
        </div>
      </div>
    </div>
  );
}

